import AccountManagers from 'components/pages/AccountManagers';
import Admins from 'components/pages/Admins';
import BillTo from 'components/pages/BillTo';
import Calendar from 'components/pages/Calendar';
import Clinics from 'components/pages/Clinics';
import Schedulers from 'components/pages/Schedulers';
import Organizations from 'components/pages/Organizations';
import Services from 'components/pages/Services';
import Staff from 'components/pages/Staff';

export const routes = [
  {
    path: '/clinics',
    component: Clinics,
  },
  {
    path: '/calendar',
    component: Calendar,
  },
  {
    path: '/schedulers',
    component: Schedulers,
  },
  {
    path: '/organizations',
    component: Organizations,
  },
  {
    path: '/services',
    component: Services,
  },
  {
    path: '/bill-to',
    component: BillTo,
  },
  {
    path: '/staff',
    component: Staff,
  },
  {
    path: '/account-managers',
    component: AccountManagers,
  },
  {
    path: '/admins',
    component: Admins,
  },
  {
    path: '/admins',
    component: Admins,
  },
];
